// extracted by mini-css-extract-plugin
module.exports = {"wrapRow":"PeerGroupMeetingDetail_wrapRow__2adRq"};